/* eslint-disable no-unused-vars */

function initFancybox() {
  // Fancybox init für die ganze Webseite
  $('[data-fancybox="*"]').fancybox({
    // Options will go here
  });
}
